<div
    class="change-password-card"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <form [formGroup]="changePasswordForm">
        <div class="row">
            <div class="col-sm-6">
                <div class="mb-25">
                    <label class="main-label d-block lh-1 text-black">
                        Stara lozinka
                    </label>
                    <mat-form-field>
                        <mat-label>
                            Unesite staru lozinku
                        </mat-label>
                        <input matInput [type]="hide ? 'password' : 'text'" formControlName="oldPassword">
                        <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                            <span class="material-symbols-outlined">
                                {{hide ? 'visibility_off' : 'visibility'}}
                            </span>
                        </button>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="mb-25">
                    <label class="main-label d-block lh-1 text-black">
                        Nova lozinka
                    </label>
                    <mat-form-field>
                        <mat-label>
                            Unesite novu lozinku
                        </mat-label>
                        <input matInput [type]="hide2 ? 'password' : 'text'" formControlName="newPassword">
                        <button mat-icon-button matSuffix (click)="hide2 = !hide2" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide2">
                            <span class="material-symbols-outlined">
                                {{hide2 ? 'visibility_off' : 'visibility'}}
                            </span>
                        </button>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="mb-25">
                    <label class="main-label d-block lh-1 text-black">
                        Potvrda
                    </label>
                    <mat-form-field>
                        <mat-label>
                            Potvrdite novu lozinku
                        </mat-label>
                        <input matInput [type]="hide3 ? 'password' : 'text'" formControlName="confirmPassword">
                        <button mat-icon-button matSuffix (click)="hide3 = !hide3" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide3">
                            <span class="material-symbols-outlined">
                                {{hide3 ? 'visibility_off' : 'visibility'}}
                            </span>
                        </button>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="btn-box">
            <button mat-button (click)="changePassword()">Promijenite lozinku</button>
            <!-- <a routerLink="/authentication/forgot-password" mat-button>
                Zaboravljena lozinka?
            </a> -->
        </div>
    </form>
</div>